var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSortDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46854 12.9375H1.53146C1.2934 12.9375 1.16047 13.1889 1.3079 13.3605L5.27644 17.9622C5.39003 18.0939 5.60876 18.0939 5.72356 17.9622L9.6921 13.3605C9.83953 13.1889 9.7066 12.9375 9.46854 12.9375Z",
    fill: "#AEB7BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6921 9.63806L5.72356 5.03629C5.60997 4.90457 5.39124 4.90457 5.27644 5.03629L1.3079 9.63806C1.16047 9.80965 1.2934 10.061 1.53146 10.061H9.46854C9.7066 10.061 9.83953 9.80965 9.6921 9.63806Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDefault);
export default __webpack_public_path__ + "static/media/icon-sort-default.30b5178b16a67b9f5b900f3932b35522.svg";
export { ForwardRef as ReactComponent };